import { root, IUtag, IUtagData } from '@estee/elc-universal-utils';
import { action, observable } from 'mobx';

export class AnalyticsDriver {
    @observable isLoaded = false;

    get utagData(): IUtagData {
        return root.utag_data;
    }

    get client(): IUtag {
        return root.utag;
    }

    public trackEvent = (data: IUtagData, cb?: Function) => {
        this.client.link(data, cb);
    };

    public pageTrack = (data: IUtagData, cb?: Function) => {
        this.client.view({ ...this.utagData, ...data }, cb);
    };

    @action
    public enable = () => {
        this.isLoaded = true;
    };
}
